import React from 'react';
import styled from 'styled-components';

import { Container, Input } from '@components/global';
import ExternalLink from '@common/ExternalLink';

import { ReactComponent as FBIcon } from '@static/icons/fb.svg';
import { ReactComponent as TwitterIcon } from '@static/icons/twitter.svg';
import { ReactComponent as IGIcon } from '@static/icons/ig.svg';

const SOCIAL = [
  {
    icon: FBIcon,
    link: '#a',
  },
  {
    icon: TwitterIcon,
    link: '#b',
  },
  {
    icon: IGIcon,
    link: '#c',
  },
];

const KNOW_MORE = [
  {
    title: 'Contact Us',
    link: '',
  },
  {
    title: 'About Us',
    link: '',
  },
  {
    title: 'Research + Innovation',
    link: '',
  },
  {
    title: 'Hard Water Shampoo',
    link: '',
  },
  {
    title: 'Squalene Restorative System',
    link: '',
  },
  {
    title: 'SmoothWave Heat Protection Serum',
    link: '',
  },
];

const POLICIES = [
  {
    title: 'Eco-conscious initiatives',
    link: '',
  },
  {
    title: 'Safety Information',
    link: '',
  },
  {
    title: 'Privacy Policy',
    link: '',
  },
];

const Footer = () => (
  <FooterWrapper>
    <Container>
      <QuickLinks>
        <div>
          <h4>Know More</h4>
          <Links>
            {KNOW_MORE.map(({ title, link }) => (
              <ExternalLink key={title} href={link}>
                {title}
              </ExternalLink>
            ))}
          </Links>
        </div>
        <div>
          <h4>Policies</h4>
          <Links>
            {POLICIES.map(({ title, link }) => (
              <ExternalLink key={title} href={link}>
                {title}
              </ExternalLink>
            ))}
          </Links>
        </div>
        <InputWrapper>
          <h4>find us in a saloon near you</h4>
          <InputField>
            <Input
              type="text"
              placeholder="Type your pincode to find saloons"
              style={{ margin: '1rem 0' }}
            />
          </InputField>
        </InputWrapper>
      </QuickLinks>
      <InfoRow>
        <div
          style={{
            padding: '0.5rem',
            border: '1px solid rgba(255,255,255,0.6)',
          }}
        >
          Vegan, SLS and SLES free, Cruelty Free, No Parabens, Phthalates,
          Eco-conscious, No Formaldehyde, Colorants
        </div>
        <div>
          <span style={{ maxWidth: 200, textAlign: 'center' }}>
            (c) 2019 Renaura Wellness Private Limited
            <br />
            Terms and conditions | Privacy policy
          </span>
        </div>
        <Cursive>Hit us up @illuvia</Cursive>
        <SocialIcons>
          {SOCIAL.map(({ icon, link }) => (
            <ExternalLink href={link} key={link}>
              {icon()}
            </ExternalLink>
          ))}
        </SocialIcons>
      </InfoRow>
    </Container>
  </FooterWrapper>
);

const FooterWrapper = styled.footer`
  background: ${props => props.theme.color.blue.gradient};
  padding: 2.5rem 0;
  color: ${props => props.theme.color.white.dark};

  h4 {
    color: ${props => props.theme.color.white.regular};
    opacity: 0.8;
    text-align: left;
  }
`;

const QuickLinks = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 5rem;

  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
  }
`;

const Links = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  a {
    text-decoration: none;
    margin: 0.1rem 0;
  }
`;

const InfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 3rem;
  justify-items: center;
  align-items: center;
  margin-top: 6rem;
  ${props => props.theme.font_size.smaller};

  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
  }
`;

const Cursive = styled.div`
  font-family: ${props => props.theme.font.cursive};
`;

const SocialIcons = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 24px);
  grid-gap: 0.5rem;

  svg:hover {
    opacity: 0.8;

    path {
      opacity: 0.8;
    }
  }
`;

const InputField = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  &::after {
    content: url('data:image/svg+xml; utf8,%3Csvg%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20opacity%3D%22.4%22%20d%3D%22M1.5%205.1h9m0%200L6%201.1m4.4%204L6%209%22%20stroke%3D%22%23fff%22%20stroke-width%3D%221.4%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E%0A');
    display: block;
    position: absolute;
    right: 0;
  }
`;

const InputWrapper = styled.div`
  grid-column: 4 / span 2;

  @media (max-width: ${props => props.theme.screen.md}) {
    grid-column: auto;
    grid-row: 1;
  }
`;

export default Footer;
